$primary-color: #7fb02f;
$secondary-color: #5a8217;

$danger-color: #d80f0f;
$danger-hover: #7d0808;
$delete-color: #747474;

.updates_main {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;

	.main_content {
		min-height: 84vh;
		max-height: 84vh;

		.title_container {
			height: 5%;
		}

		.content_container {
			height: 95%;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}
		}

		.update_list {
			margin: 2rem 0;

			.date {
				color: $primary-color !important;
				font-size: 1.5rem;
				display: flex;
				justify-content: flex-end;
			}

			.content {
				border-left: 5px solid $secondary-color;
				position: relative;
				padding: 1rem 0.5rem 1rem 2rem;
				background-color: #fff;
				border-radius: 0 5px 5px 0;
				animation: fade-in 1s;

				--tw-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
				--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 0.5px 2px var(--tw-shadow-color);
				box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

				.badge_publish {
					font-weight: 400;
					cursor: pointer;
				}

				&:hover {
					background-color: #fcfcfc;
					box-shadow: 1px 1px 15px 5px rgba(0, 0, 0, 0.1);
				}

				h3 {
					text-transform: uppercase;
					margin-bottom: 1rem;
				}

				.detail_container {
					list-style: none;
					margin: 1rem;

					li {
						margin: 0;
					}
					iframe {
						width: 100%;
						height: 300px;
					}
				}

				.user {
					margin-top: 1rem;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					p {
						margin: 0 0.7rem;
					}
					.image {
						width: 2rem;
						height: 2rem;
						border-radius: 50%;
					}
					.icon {
						height: 1rem;
						width: 1rem;
						margin: 0 0.3rem;
						cursor: pointer;
						fill: $primary-color;
					}
				}

				.ckeditor_buttons {
					margin-top: 1rem;
					display: flex;
					justify-content: flex-end;

					.danger_btn {
						background-color: $danger-color !important;
						margin-right: 1rem;

						&:hover {
							background-color: $danger-hover !important;
						}
					}
					.success_btn {
						background-color: $primary-color !important;

						&:hover {
							background-color: $secondary-color !important;
						}
					}
				}

				.update_header {
					display: flex;
					justify-content: space-between;

					.close_icon {
						width: 1.3em;
						height: 1.3em;
						fill: $delete-color;

						&:hover {
							fill: $danger-color;
							cursor: pointer;
						}
					}
				}

				.base_ckeditor {
					width: 95%;

					figure {
						width: 100%;

						div {
							width: 95%;
						}
						img {
							width: 100%;
						}
					}

					img {
						max-width: 100%;
						max-height: 30em;
						height: auto;
						width: auto;
						object-fit: contain;
					}
				}
			}
		}
		.media {
			width: 150px;
			height: 150px;
		}
		@keyframes fade-in {
			0% {
				opacity: 0;
			}
			50% {
				opacity: 0.5;
			}
			100% {
				opacity: 1;
			}
		}
	}
}
